import { dateComparator } from "utils/comparatorUtils";
import { formatTime } from "utils/insightsAndAlarmsUtils";
import { dateRangeFilter } from "utils/utils";
import { ALARMS_TABLE_STRINGS } from "constants/constantStrings";
import { LOCAL_TZ_CODE } from "constants/globalConstants";

export const CHART_ALAMRS_TABEL_COL_DEF = [
  {
    field: "",
    headerName: ALARMS_TABLE_STRINGS.headerAlarmDisplay,
    flex: 1,
    editable: false,
    sortable: false,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: true
  },
  {
    field: "AlarmId",
    headerName: ALARMS_TABLE_STRINGS.headerAlarmID,
    flex: 1,
    editable: false,
    sortable: true
  },
  {
    field: "AlarmName",
    headerName: ALARMS_TABLE_STRINGS.headerAlarmName,
    flex: 2,
    editable: false,
    sortable: true
  },
  {
    field: "Description",
    flex: 3,
    headerName: ALARMS_TABLE_STRINGS.headerAlarmDesc,
    editable: false,
    sortable: true
  },
  {
    field: "TimeStamp",
    filter: "agDateColumnFilter",
    filterParams: dateRangeFilter,
    flex: 1.5,
    headerName: ALARMS_TABLE_STRINGS.headerAlarmTimestamp,
    editable: false,
    sortable: true,
    defaultSort: "desc",
    valueFormatter: params => `${formatTime(params, "TimeStamp")} ${LOCAL_TZ_CODE}`,
    comparator : dateComparator
  }
];

export const getAlarmsTableColDef = filter =>
  CHART_ALAMRS_TABEL_COL_DEF.map((colDef, idx) => {
    if (idx !== 0 && idx !== 4) {
      colDef = { ...colDef, filter };
    }
    return colDef;
  });